import { formatCase } from "utils/prismic"
import ContentPageContainer from "components/molecules/common/ContentPageContainer"
import { RichText } from "prismic-reactjs"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import * as styles from "./blogTemplate.module.css"
import "styles/index.global.css"

export default function TestimonialTemplate({ pageContext: { content } }) {
  const { title, avatar, quote, quoteAuthor, body, tag } = formatCase(content)

  return (
    <ContentPageContainer title={title}>
      <div className={styles.content}>
        <div className="mb-6 flex flex-col sm:flex-row">
          <GatsbyImage
            image={getImage(avatar)}
            className=" mx-auto h-36 w-36 shrink-0 rounded-full"
          />
          <blockquote className="content mb-0 grow whitespace-pre-line text-left font-body text-base text-zinc-800">
            {quote}
            <div className="mt-4 text-right text-base text-stone-800">
              <p className="m-0 font-extrabold">{quoteAuthor}</p>
            </div>
          </blockquote>
        </div>
        <div className="flex flex-col items-start">
          <RichText render={body} />
        </div>
      </div>
    </ContentPageContainer>
  )
}
